import angular from 'angular';
import '../core.module';

class ChannelOperationsApiService {
  constructor($http, API_BASE_URL) {
    this.$http = $http;
    this.API_BASE_URL = API_BASE_URL;
  }

  execute(channelId, operationId, args, options) {
    const body = { args };
    if (options && options.confirm === true) body.confirm = true;
    return this.$http
      .post(`${this.API_BASE_URL}/channels/${channelId}/operations/${operationId}`, body)
      .then((response) => response.data);
  }
}

ChannelOperationsApiService.$inject = ['$http', 'API_BASE_URL'];

angular.module('app.core').service('ChannelOperationsApiService', ChannelOperationsApiService);

export default ChannelOperationsApiService;
